module.exports = __webpack_public_path__ + "img/brought-to-you-mobile-fr.3bfc3dc5.png";